import { UsersTypes } from './actionTypes';

export const getUsers = (data: any) => ({
  type: UsersTypes.GET_USERS,
  payload: data,
});

export const getUserEmail = (data: any) => ({
  type: UsersTypes.GET_USER_EMAIL,
  payload: data,
});

export const getUsersSuccess = (users: any) => {
  return {
    type: UsersTypes.GET_USERS_SUCCESS,
    payload: users,
  };
};

export const getUsersFail = (error: any) => ({
  type: UsersTypes.GET_USERS_FAIL,
  payload: error,
});

export const getUsersDetail = (permissionId: number) => ({
  type: UsersTypes.GET_USERS_DETAIL,
  permissionId,
});

export const getUsersDetailSuccess = (users: any) => ({
  type: UsersTypes.GET_USERS_DETAIL_SUCCESS,
  payload: users,
});

export const getUsersDetailFail = (error: any) => ({
  type: UsersTypes.GET_USERS_DETAIL_FAIL,
  payload: error,
});

export const addUsers = (usersAdd: any) => {
  return {
    type: UsersTypes.ADD_USERS,
    payload: { usersAdd },
  };
};

export const addUsersSuccess = (usersAdd: any) => {
  return {
    type: UsersTypes.ADD_USERS_SUCCESS,
    payload: usersAdd,
  };
};

export const addUsersFail = (error: any) => {
  return {
    type: UsersTypes.ADD_USERS_FAIL,
    payload: error,
  };
};

export const deleteUsers = (data: any) => {
  return {
    type: UsersTypes.DELETE_USERS,
    payload: data,
  };
};

export const deleteUsersSuccess = (payload: any) => {
  return {
    type: UsersTypes.DELETE_USERS_SUCCESS,
    payload,
  };
};

export const deleteUsersFail = (error: any) => {
  return {
    type: UsersTypes.DELETE_USERS_FAIL,
    payload: error,
  };
};

export const updateUsers = (users: any) => {
  return {
    type: UsersTypes.UPDATE_USERS,
    payload: { users },
  };
};

export const updateUsersSuccess = (users: any) => {
  return {
    type: UsersTypes.UPDATE_USERS_SUCCESS,
    payload: users,
  };
};

export const updateUsersFail = (error: any) => {
  return {
    type: UsersTypes.UPDATE_USERS_FAIL,
    payload: error,
  };
};

export const setNewPasswordRequest = (data: any) => ({
  type: UsersTypes.PASSWORD_REQUEST_USERS,
  payload: data,
});

export const setNewPasswordRequestSucess = (data: any) => ({
  type: UsersTypes.PASSWORD_REQUEST_USERS_SUCCESS,
  payload: data,
});

export const updatePasswordUsers = (users: any) => {
  return {
    type: UsersTypes.PASSWORD_REQUEST_UPDATE_USERS,
    payload: { users },
  };
};
export const updatePasswordRequestSucess = (data: any) => ({
  type: UsersTypes.PASSWORD_REQUEST_UPDATE_USERS_SUCCESS,
  payload: data,
});
